import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import SabeeAppHtmlRenderer from './Renderer/SabeeAppHtmlRenderer';
const SabeeAppControls = lazyLoad(() => import('./Controls/SabeeAppControls'));
const buttonPlugin = (settings) => createPlugin(Object.assign({ Renderer: SabeeAppHtmlRenderer, Controls: SabeeAppControls }, settings));
const button = buttonPlugin();
export default button;
export { buttonPlugin };
//# sourceMappingURL=index.js.map